import { AppConstants } from '@core-lib/config';

export function checkMontantFormat(value: any): number {
    if (typeof value === 'string') {
        value = value.replaceAll(' ', '');
        return parseFloat(value.replace(',', '.'));
    } else {
        return value;
    }
}

export function getMontantSeparator(nombreDecimales?: number): string {
    return `separator.${nombreDecimales ?? 2}`;
}

export function formatMontant(value: any, configurationNumber?: number, withAmountSeparation: boolean = true): string {
    value = value?.toString() ?? '';
    let wasComma: boolean = false;
    let targetValue: any = value.replace(/\s/g, '');

    if (targetValue.includes(',')) {
        targetValue = targetValue.replace(',', '.');
        wasComma = true;
    }

    targetValue = parseFloat(targetValue);
    targetValue = targetValue.toFixed(configurationNumber >= 0 ? configurationNumber : AppConstants.CURRENCY_MASK_OPTIONS.precision);

    if (!!withAmountSeparation) {
        const parts = targetValue.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        targetValue = parts.join();
    }

    if (wasComma) {
        targetValue = targetValue.replace('.', ',');
    }

    return targetValue;
}

export function formatMontantToDb(montant: string): string {
    return montant?.includes('.') ? montant : montant.replace(',', '.');
}

export function parseMontant(value: string | number): number {
    if (typeof value === 'number') return value;
    if (!value) return 0;

    // Supprime les espaces
    let cleaned = value.replace(/\s/g, '');
    // Remplace la virgule par un point pour le décimal
    cleaned = cleaned.replace(',', '.');

    const result = Number(cleaned);
    return isNaN(result) ? 0 : result;
}
